import { render, staticRenderFns } from "./Thaibev.vue?vue&type=template&id=70463dd2&"
import script from "./Thaibev.vue?vue&type=script&lang=js&"
export * from "./Thaibev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports